import {
	FilterConfiguration,
	FilterTypes,
} from "components/Shared/GlobalFilter/types"
import { ALL_CODE, ALL_NAME } from "helpers/service"
import { Tuple } from "../Interfaces"
import { useHistory } from "react-router-dom"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"

export const createFiltersByConfiguration = (
	filtersToShow: Array<FilterTypes>,
	filterList: FilterConfiguration
) => {
	const newFilters: FilterConfiguration = {}
	filtersToShow.forEach((filter) => {
		newFilters[filter] = filterList[filter]
	})
	return newFilters
}

export const addAllOption = (options: Array<Tuple>) => [
	{ code: ALL_CODE, name: ALL_NAME },
	...options,
]
export const checkAllValues = (
	checked: boolean,
	setCheckedValues: React.Dispatch<React.SetStateAction<Tuple[]>>,
	options: Array<Tuple>
) => (checked ? setCheckedValues(options) : setCheckedValues([]))

const updateSelectedCheckbox = (
	target: EventTarget & HTMLInputElement,
	setCheckedValues: React.Dispatch<React.SetStateAction<Tuple[]>>,
	checkedValues: Array<Tuple>
) => {
	const { value: code, name, checked } = target

	return checked
		? setCheckedValues([...checkedValues, { code, name }])
		: setCheckedValues(
				checkedValues.filter(
					(item) => item.code !== code && item.code !== ALL_CODE
				)
		  )
}

export const handleOnChange = (
	target: EventTarget & HTMLInputElement,
	setterFunction: React.Dispatch<React.SetStateAction<Tuple[]>>,
	options: Array<Tuple>,
	checkedValues: Array<Tuple>
) => {
	const { value: code, checked } = target

	return code === ALL_CODE
		? checkAllValues(checked, setterFunction, options)
		: updateSelectedCheckbox(target, setterFunction, checkedValues)
}

const decodeDataStored = (keyName: string) =>
	atob(sessionStorage.getItem(keyName) || btoa("{}"))

export const getFiltersDataFromStorage = (
	keyName: string,
	fetchFiltersData: () => void,
	setFiltersData: React.Dispatch<React.SetStateAction<any>>
) => {
	const filtersDataStored = decodeDataStored(keyName)
	if (!filtersDataStored || filtersDataStored === "{}") {
		fetchFiltersData()
	} else {
		setFiltersData(JSON.parse(filtersDataStored))
	}
}

export const removeDuplicatedVendors = (vendors: Array<Tuple>): Array<Tuple> =>
	vendors.filter(
		(value, index, self) =>
			index === self.findIndex((selfItem) => value.code === selfItem.code)
	)

export const detectionSwitchingModule = () => {
	const history = useHistory()
	const pathSwitching = "/switching"
	const currentPathname = history.location.pathname
	return currentPathname.includes(pathSwitching)
}

const mapGlobalFilterCode = (tuple: Tuple) => tuple.code

export const mapGlobalFilters = (
	globalFilters: FiltersType,
	fieldsToMap: Record<keyof FiltersType, string>
) =>
	Object.entries(fieldsToMap).reduce((acc, [key, keyOut]) => {
		acc[keyOut] = globalFilters[key]?.map(mapGlobalFilterCode)?.join(",") || ""
		return acc
	}, {} as Record<string, string>)
